import { render, staticRenderFns } from "./FormSectionHeader.vue?vue&type=template&id=594dbba2&scoped=true&"
import script from "./FormSectionHeader.vue?vue&type=script&lang=js&"
export * from "./FormSectionHeader.vue?vue&type=script&lang=js&"
import style0 from "./FormSectionHeader.vue?vue&type=style&index=0&id=594dbba2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594dbba2",
  null
  
)

export default component.exports